import { TmApiClientError } from '@/core/error/transport/tmApiClientError'
import type { TmTransportHttpErrorCode } from '@/core/error/transport/types'

export class TmApiTooLargeError extends TmApiClientError {
  public name = 'TmApiTooLargeError'

  protected override code: TmTransportHttpErrorCode = 413
}
